/**
 * Parse a Scryfall mana cost string into symbol tokens.
 * e.g. "{2}{W}{U}" → ["{2}", "{W}", "{U}"]
 */
export function parseManaCost(manaCost) {
    return manaCost.match(/\{[^}]+\}/g) ?? [];
}
/**
 * Convert a mana symbol token to a Scryfall SVG key.
 * e.g. "{W}" → "W", "{2/W}" → "2W", "{W/P}" → "WP"
 */
export function symbolToKey(symbol) {
    return symbol.slice(1, -1).replace(/\//g, '');
}
//# sourceMappingURL=mana-parser.js.map